import {Component, OnInit, Injector, AfterViewInit, Input, OnDestroy} from '@angular/core';
import {AppComponentBase} from '../../../../services/AppComponentBase';
import {ScannerSide, ScannerChartingStudy} from '../../interfaces/scanner.enums';
import {IRSIScanRule, IMACDScanRule, chartingSaved} from '../../interfaces/scanner.interfaces';



@Component({
    selector: 'app-scanner-MACD',
    template: require('./scanner-MACD.component.html'),
    styles: [require('./scanner-MACD.component.scss')]
})
export class ScannerMACDSelectorComponent extends AppComponentBase implements OnInit, AfterViewInit, OnDestroy {
    ngAfterViewInit(): void {
        let v = this.workspace.initLoadScan;
        if(v != null) {
            this.loadScanData(v);
            //  this.workspace.initLoadScan = null;
        }
    }

    public loadScanData(v: any) {
        let loadScanData: chartingSaved = (!this.narrowScannerMode) ? <chartingSaved> v.savedData : <chartingSaved> v.savedDataSecondary;
        //console.log(v);
        this.workspace.scannerSearch_period = loadScanData.period;

        let scanRule: IMACDScanRule = <IMACDScanRule> loadScanData.rule;
        this.fastPeriod = scanRule.fast_period;
        this.slowPeriod = scanRule.slow_period;
        this.signalPeriod = scanRule.signal_period
        this.workspace.scannerSearch_side = scanRule.direction;
        this.enableAdvancedSetup = true;

        if(scanRule.direction == ScannerSide.SCANNER_SIDE_BUY) {
            this.overbought = true;

        }
        if(scanRule.direction == ScannerSide.SCANNER_SIDE_SELL) {
            this.oversold = true;

        }
        this.workspace.canSelectedSavedScanUpdate = false;
        this.workspace.allowScanProcess = true;
    }

    constructor(injector: Injector) {
        super(injector);

        if(!this.workspace.isNarrowScanMode) {
            this.workspace.scannerSearch_side = ScannerSide.SCANNER_SIDE_BUY;
            this.scanRule = {direction: this.workspace.scannerSearch_side, fast_period: this.fastPeriod, slow_period: this.slowPeriod, signal_period: this.signalPeriod};
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
        }


        this.workspace.globaGridMode.changeScannerSide.subscribe(v => {
            if(!this.narrowScannerMode) {
                if(this.workspace.scannerSearch_chartingstudy == ScannerChartingStudy.SCANNER_MACD) {
                    if(v == ScannerSide.SCANNER_SIDE_BUY) {
                        this.overbought = true;
                        this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
                    }
                    if(v == ScannerSide.SCANNER_SIDE_SELL) {
                        this.oversold = true;
                        this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
                    }
                }
            }
        })

        this.workspace.globaGridMode.changeScannerNarrowSide.subscribe(v => {
            if(this.narrowScannerMode) {
                if(this.workspace.scannerSearch_Narrow_chartingstudy == ScannerChartingStudy.SCANNER_MACD) {
                    if(v == ScannerSide.SCANNER_SIDE_BUY) {
                        this.overbought = true;
                        this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
                    }
                    if(v == ScannerSide.SCANNER_SIDE_SELL) {
                        this.oversold = true;
                        this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
                    }
                }
            }
        })





        this.workspace.globaGridMode.loadScannerRule.subscribe(v => {

            if(v.study == ScannerChartingStudy.SCANNER_MACD)
                this.loadScanData(v)

        });
    }
    public subscribers: any = {};
    ngOnDestroy() {
        //   this.subscribers.load.unsubscribe();
    }
    public _narrowScannerMode: boolean = false;

    @Input() public set narrowScannerMode(value: boolean) {
        this._narrowScannerMode = value
        if(value == true) {
            this.workspace.scannerSearch_Narrow_side = ScannerSide.SCANNER_SIDE_BUY;
            this.scanRule = {direction: this.workspace.scannerSearch_Narrow_side, fast_period: this.fastPeriod, slow_period: this.slowPeriod, signal_period: this.signalPeriod};
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }
    }

    public get narrowScannerMode() {
        return this._narrowScannerMode;
    }


    //value: number = 5;

    private _fastPeriod: number = 24;
    public get fastPeriod(): number {
        return this._fastPeriod;
    }
    public set fastPeriod(value: number) {
        this._fastPeriod = value < 1 ? 1 : value;
        if(!this.narrowScannerMode) {
            this.scanRule = {direction: this.workspace.scannerSearch_side, fast_period: this.fastPeriod, slow_period: this.slowPeriod, signal_period: this.signalPeriod};
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
        }
        else {
            this.scanRule = {direction: this.workspace.scannerSearch_Narrow_side, fast_period: this.fastPeriod, slow_period: this.slowPeriod, signal_period: this.signalPeriod};
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }
    }

    public get isFastPeriodValid() {
        return !isNaN(Number(this.fastPeriod))
    }


    private _slowPeriod: number = 12;
    public get slowPeriod(): number {
        return this._slowPeriod;
    }
    public set slowPeriod(value: number) {
        this._slowPeriod = value < 1 ? 1 : value;
        if(!this.narrowScannerMode) {
            this.scanRule = {direction: this.workspace.scannerSearch_side, fast_period: this.fastPeriod, slow_period: this.slowPeriod, signal_period: this.signalPeriod};
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
        }
        else {
            this.scanRule = {direction: this.workspace.scannerSearch_Narrow_side, fast_period: this.fastPeriod, slow_period: this.slowPeriod, signal_period: this.signalPeriod};
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }
    }

    public get isSlowPeriodValid() {
        return !isNaN(Number(this.slowPeriod))
    }


    private _signalPeriod: number = 7;
    public get signalPeriod(): number {
        return this._signalPeriod;
    }
    public set signalPeriod(value: number) {
        this._signalPeriod = value < 1 ? 1 : value;
        if(!this.narrowScannerMode) {
            this.scanRule = {direction: this.workspace.scannerSearch_side, fast_period: this.fastPeriod, slow_period: this.slowPeriod, signal_period: this.signalPeriod};
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
        }
        else {
            this.scanRule = {direction: this.workspace.scannerSearch_Narrow_side, fast_period: this.fastPeriod, slow_period: this.slowPeriod, signal_period: this.signalPeriod};
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }
    }

    public get isSingnalPeriodValid() {
        return !isNaN(Number(this.signalPeriod))
    }


    private _enableAdvancedSetup: boolean = false;
    public get enableAdvancedSetup(): boolean {
        return this._enableAdvancedSetup;
    }
    public set enableAdvancedSetup(value: boolean) {
        this._enableAdvancedSetup = value;
    }

    public get isBandSelectedValid() {
        return this.overbought || this.oversold;
    }

    private _overbought: boolean = true;
    public get overbought(): boolean {
        return this._overbought;
    }
    public set overbought(value: boolean) {
        this._overbought = value;
        this._oversold != value;
        if(value == true) {

            if(!this.narrowScannerMode) {
                this.workspace.scannerSearch_side = ScannerSide.SCANNER_SIDE_BUY;
                this.scanRule = {direction: this.workspace.scannerSearch_side, fast_period: this.fastPeriod, slow_period: this.slowPeriod, signal_period: this.signalPeriod};
            }
            else {
                if(this.workspace.usePrimarySide) {
                    return
                }
                this.workspace.scannerSearch_Narrow_side = ScannerSide.SCANNER_SIDE_BUY;
                this.scanRule = {direction: this.workspace.scannerSearch_Narrow_side, fast_period: this.fastPeriod, slow_period: this.slowPeriod, signal_period: this.signalPeriod};
            }

            this.oversold = false;

        }
        if(!this.narrowScannerMode) {
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
        }
        else {
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }

    }


    private _oversold: boolean = false;
    public get oversold(): boolean {
        return this._oversold;
    }
    public set oversold(value: boolean) {
        this._oversold = value;
        this._overbought = !value;
        if(value == true) {

            if(!this.narrowScannerMode) {
                this.workspace.scannerSearch_side = ScannerSide.SCANNER_SIDE_SELL;
                this.scanRule = {direction: this.workspace.scannerSearch_side, fast_period: this.fastPeriod, slow_period: this.slowPeriod, signal_period: this.signalPeriod};
            }
            else {
                if(this.workspace.usePrimarySide) {
                    return
                }
                this.workspace.scannerSearch_Narrow_side = ScannerSide.SCANNER_SIDE_SELL;
                this.scanRule = {direction: this.workspace.scannerSearch_Narrow_side, fast_period: this.fastPeriod, slow_period: this.slowPeriod, signal_period: this.signalPeriod};
            }

            this.overbought = false;
        }

        if(!this.narrowScannerMode) {
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
        }
        else {
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }


    }


    public overboughtAction() {
        this.overbought = !this.overbought
    }

    public oversoldAction() {
        this.oversold = !this.oversold
    }






    ngOnInit() {
    }


    public scanRule: IMACDScanRule = {direction: this.workspace.scannerSearch_side, fast_period: this.fastPeriod, slow_period: this.slowPeriod, signal_period: this.signalPeriod}


}

